import { Box } from '@mui/material'
import { inlineCodeSx } from '../inlineCodeSx'

/** Single-line `code` spans. Fenced blocks go to `CodeBlock` instead. */
export default function InlineCode({ children }) {
  return <Box component="code" sx={inlineCodeSx}>{children}</Box>
}
